<template>
    <b-container>
        <b-row align-v="center">
            <b-col md="5">
                <dropdown-nav ref="dropdownNav" key="shopCategoriesNav" arrow="left" toggler-class="header-nav-item">
                    <template slot="label">
                        SHOP
                    </template>
                    <div class="dropdown-category-menu">
                        <h5>CATEGORY</h5>
                        <hr class="left"/>
                        <div class="dropdown-category-menu-scroller">
                            <b-nav v-if="user" vertical @mouseover="toggleCategory(null)" class="header-nav-list">
                                <b-nav-item :key="customerCategory.id"
                                            class="special"
                                            active-class="active"
                                            @click.stop="$refs.dropdownNav.forceHide()"
                                            :to="{ name: 'customer', params: {id: customerCategory.id} }"
                                            v-for="(customerCategory) in customerShopList">
                                    {{ customerCategory.webName }}
                                </b-nav-item>
                                <b-nav-item v-if="canRead('DESIGN_SHOP')" @click.stop="$refs.dropdownNav.forceHide()"
                                            active-class="active" class="special primary" :to="{ name: 'theme-select'}">
                                    Trend
                                    Shop
                                </b-nav-item>
                            </b-nav>
                            <b-nav vertical class="header-nav-list">
                                <b-nav-item :key="category.id" @mouseover="toggleCategory(category)"
                                            active-class="active"
                                            @click.stop="$refs.dropdownNav.forceHide()"
                                            :active="($route.params && $route.params.parentCategory == category.id) || (!$route.params.parentCategory && selectedCategory && selectedCategory.id === category.id)"
                                            :to="{ name: 'category', params: {id: category.id} }"
                                            v-for="(category) in filteredCategories">
                                    {{ category.webName }}
                                </b-nav-item>
                            </b-nav>
                        </div>
                    </div>
                    <div class="p-3" style="min-width: 340px;padding: 20px;" vertical v-if="selectedCategory">
                        <h5>{{ selectedCategory.webName || selectedCategory.name }}</h5>
                        <hr class="left"/>
                        <b-nav vertical class="header-nav-list">
                            <b-nav-item v-for="(cat) in selectedCategory.childrenCategoryList"
                                        active-class="active"
                                        @click.stop="$refs.dropdownNav.forceHide()"
                                        :to="{ name: 'category', params: {id: cat.id, parentCategory: selectedCategory.id} }"
                                        v-bind:key="cat.id">
                                {{ cat.webName || cat.name }}
                            </b-nav-item>
                        </b-nav>
                    </div>
                </dropdown-nav>
                <dropdown-nav key="companyNavigation" class="mx-5" toggler-class="header-nav-item">
                    <template slot="label">
                        COMPANY
                    </template>
                    <div style="padding: 20px;">
                        <b-nav vertical class="header-nav-list">
                            <b-nav-item active-class="active" :key="route.id" :to="route.path.value"
                                        v-for="(route) in filteredNavItems" class="">
                                {{ route.label.value }}
                            </b-nav-item>
                        </b-nav>
                    </div>
                </dropdown-nav>
                <dropdown-nav v-if="user && user.supplierList && user.supplierList.length > 0" key="supplierNav" toggler-class="header-nav-item">
                    <template slot="label">
                        SUPPLIER
                    </template>
                    <div style="padding: 20px;">
                        <b-nav v-if="user.supplierList.length > 1" vertical class="header-nav-list">
                           <b-nav-item active-class="active" :key="supplier.id" :to="'/supplier/' + supplier.id + '/orders'"
                                       v-for="(supplier) in user.supplierList" class="">
                              {{ supplier.name }}
                           </b-nav-item>
                        </b-nav>
                       <b-nav v-else vertical class="header-nav-list">
                          <b-nav-item active-class="active" :to="'/supplier/' + user.supplierList[0].id + '/orders'" class="">
                             Orders
                          </b-nav-item>
                       </b-nav>
                    </div>
                </dropdown-nav>
            </b-col>
            <b-col md="2" class="text-center">
                <span class="logo">
                    <a href="/"><img width="93px" src="@shared/_assets/img/logo.png"/></a>
                </span>
            </b-col>
            <b-col md="5" class="text-right">
                <div class="user-bar">
                    <user-bar v-if="user"></user-bar>
                    <login-bar v-else></login-bar>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import NavbarBase from "./NavbarBase";
    import {mapState} from "vuex";
    import LoginBar from "./LoginBar";
    import UserBar from "./UserBar";

    export default {
        name: 'navbar',
        extends: NavbarBase,
        components: {
            'user-bar': UserBar,
            'login-bar': LoginBar
        },
        computed: {
            ...mapState('account', ['user'])
        }
    }
</script>

<style lang="scss" scoped>

</style>
